import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

export const HeaderSection = styled("header")`
  padding: 0.1rem 0.1rem;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(5px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
`;

export const LogoTitle = styled.span`
  margin: 0;
  font-size: 30px;
  color: #111111;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
  'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
  sans-serif;
  font-weight: 400;
  display: inline-block;
  vertical-align: middle;
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const Burger = styled("div")`
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    fill: #2e186a;
  }
`;

export const MobileCluster = styled("div")`
  display: none;

  @media only screen and (max-width: 890px) {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }
`;

export const NotHidden = styled("div")`
  display: flex;
  align-items: center;

  @media only screen and (max-width: 890px) {
    display: none;
  }
`;

export const Menu = styled("h5")`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 1.2rem;
  color: #18216d;
  transition: color 0.2s ease-in;
  margin: 0.5rem 2rem;

  @media only screen and (max-width: 768px) {
    margin: 1.25rem 2rem;
  }
`;

export const Label = styled("span")`
  font-weight: 500;
  color: #404041;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Outline = styled(MenuOutlined)`
  font-size: 22px;
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: rgb(255, 130, 92);
    text-underline-position: under;
    text-decoration: rgb(255, 130, 92) wavy underline;
  }
`;

export const LoginButton = styled("button")`
  background: #000;
  color: #fff;
  border: none;
  border-radius: 999px;
  padding: 0.5rem 1.25rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  margin: 0.5rem 1rem;
  transition: background 0.2s ease-in-out;
  font-family: inherit;

  &:hover,
  &:focus {
    background: #1d1d1f;
    outline: none;
  }

  @media only screen and (max-width: 890px) {
    margin: 0;
    padding: 0.4rem 0.95rem;
    font-size: 0.9rem;
  }
`;

export const ProfileWrapper = styled("div")`
  position: relative;
  display: inline-flex;
  margin: 0.5rem 1rem;

  @media only screen and (max-width: 890px) {
    margin: 0;
  }
`;

export const ProfileCircle = styled("button")`
  width: 36px;
  height: 36px;
  border-radius: 999px;
  background: #000;
  color: #fff;
  border: none;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
  padding: 0;
  transition: background 0.2s ease-in-out;

  &&:hover,
  &&:focus {
    background: #1d1d1f;
    color: #fff;
    outline: none;
    transform: none;
    box-shadow: none;
  }

  @media only screen and (max-width: 890px) {
    width: 32px;
    height: 32px;
    font-size: 0.85rem;
  }
`;

export const ProfileMenuPanel = styled("div")`
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 140px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  padding: 6px;
  z-index: 1500;
`;

export const ProfileMenuItem = styled("button")`
  display: block;
  width: 100%;
  text-align: left;
  background: transparent;
  border: none;
  border-radius: 6px;
  padding: 0.55rem 0.75rem;
  font-size: 0.95rem;
  color: #1d1d1f;
  cursor: pointer;
  font-family: inherit;

  &&:hover,
  &&:focus {
    background: #f3f4f6;
    color: #1d1d1f;
    outline: none;
    transform: none;
    box-shadow: none;
  }
`;
